import {Plugins} from '@packages/systems/wfdl';
import {TargetIcon} from '@packages/systems/spring';
import OptimizationExperienceAtom from './OptimizationExperienceAtom';
import OptimizationTreatmentAtom from './OptimizationTreatmentAtom';
import OptimizationBaseAtom from './OptimizationBaseAtom';

export default Plugins.PrivilegedPlugin({
  atoms: {
    OptimizationExperience: OptimizationExperienceAtom,
    OptimizationTreatment: OptimizationTreatmentAtom,
    OptimizationBase: OptimizationBaseAtom,
  },
  icons: {
    OptimizationExperience: TargetIcon,
    OptimizationVariation: TargetIcon,
  },
  dataTypes: {},
  values: {},
  elementPresets: {},
});
